/*
 * @Description: 
 * @Date: 2021-12-10 11:18:08
 * @Author: didi
 * @LastEditTime: 2025-08-15 10:14:22
 */
/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 后台管理系统服务器地址
//export const baseUrl = 'http://172.16.10.85:8082'
//export const baseUrl = 'http://172.16.10.33:8082'
//export const baseUrl = "http://172.16.10.215:8082";
//export const baseUrl = "https://back.rensheju.com";
// 测试上线
export const baseUrl = "https://back.rensheju.com";
// 测试 测试
// export const baseUrl = "http://172.16.10.114:8081";
//export const baseUrl = "http://172.16.10.215:8082";
export const baseUrlPanter = "http://web.kanface.com";
export const addressUrl = "https://rsaddr.kanface.com";
//export const baseUrl = 'http://222.65.163.143:8082'
//export const baseUrl2 = 'http://172.16.10.18:8082'
//export const baseUrl = 'http://47.101.206.243:8080'
//export const areaUrl = 'http://xclc.rensheju.com'
export default {
  baseUrl,
  //baseUrl2,
  addressUrl
};



// WEBPACK FOOTER //
// ./src/utils/global.js